import React, { useEffect, useState } from 'react';
import './index.css';
import clsx from 'classnames';
import { Pagination, Position, Empty } from 'components';
import QueueAnim from 'rc-queue-anim';
import NewsItem from './components/NewsItem';
import { useNewsList, usePageTitle } from '../../hooks';
import { isEmpty } from '../../utils/utils';
import { useAppContext } from 'context';

// 顶部banner
const bannerList = [
  {
    img: '/img/newsBig.jpg',
    className: 'news-top-banner-big',
  },
  {
    img: '/img/newsSmall.jpg',
    className: 'news-top-banner-small',
  },
];
const News = () => {
  // 设置页面标题
  usePageTitle('新闻动态');
  const {
    state: { newsCurrentPage },
    dispatch,
  } = useAppContext();

  // 获取产品列表数据
  const { data, loading, refresh } = useNewsList(
    {
      pageNo: newsCurrentPage,
      pageSize: 7,
    },
    { immediate: false },
  );
  const newsList = data?.list;
  const totalCount = data?.totalCount;

  useEffect(() => {
    refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newsCurrentPage]);

  // 根据peoductArr数据进行数据重组已七条数据为一页，返回重组数组以及相关的页数
  const totalPages = Math.ceil(totalCount / 7);

  return (
    <div className={clsx('news-top')} style={{ minHeight: window.innerHeight }}>
      {/* 顶部Banner */}
      {bannerList.map((v, index) => {
        return (
          <img
            key={index}
            src={v.img}
            alt=''
            width={'100%'}
            height={'100%'}
            className={clsx(v.className)}
          />
        );
      })}
      {/* 当前位置 */}
      <Position list={['首页', '新闻动态']} />
      <QueueAnim className={clsx('news-content')} type={['right', 'left']}>
        {!loading
          ? [
              <div
                className={clsx('news-content-title')}
                key='news-content-title'
              >
                新闻中心
              </div>,
              <div
                className={clsx('news-content-list')}
                key='news-content-list'
              >
                {!isEmpty(newsList) ? (
                  newsList?.map((v, index) => {
                    return <NewsItem v={v} key={index} />;
                  })
                ) : (
                  <Empty />
                )}
              </div>,
              //  页码
              <div key='pagination'>
                {totalPages > 1 && (
                  <Pagination
                    totalPages={totalPages}
                    currentPage={newsCurrentPage}
                    onChange={(page) => {
                      // setCurrentPage(page);
                      dispatch({
                        type: 'SET_NEWS_CURRENT_PAGE',
                        payload: page,
                      });
                    }}
                  />
                )}
              </div>,
            ]
          : null}
      </QueueAnim>
    </div>
  );
};

export default News;
